import { t } from '../../../../modules/infra/i18n';

export const getColumns = () => [
  { label: t('customers:marketing_leads.acquisition_channel_label'), key: 'name' },
  { label: t('customers:marketing_leads.percentage_of_clients'), key: 'newCustomersPercentage', type: 'percentage', valueFormat: Number },
  { label: t('customers:marketing_leads.number_of_clients'), key: 'totalCustomers', valueFormat: Number },
];

// Actions
export const CLEAR_ITEMS = 'marketingLeads/CLEAR_ITEMS';
export const FETCH_ITEMS = 'marketingLeads/FETCH_ITEMS';
export const FETCH_ITEM = 'marketingLeads/FETCH_ITEM';
export const UPDATE_ITEM = 'marketingLeads/UPDATE_ITEM';
export const ADD_ITEM = 'marketingLeads/ADD_ITEM';
export const DELETE_ITEM = 'marketingLeads/DELETE_ITEM';
